import { useQuery } from '@tanstack/react-query';
import { getAllPenalties, PenaltiesResponse, PenaltyPaymentDto } from 'services/api/penalty-api.service';
import { QueryKey } from 'common/enums/query-key';
import { useUserProfileValidation } from 'hooks/query';

export const usePenaltyPayments = () => {
  const { data: userValidation } = useUserProfileValidation();
  const shouldFetchPenalties = userValidation?.isNoPenalty === false;

  const queryResult = useQuery<PenaltiesResponse, Error>({
    queryKey: [QueryKey.User, 'penalties', 'late-countersign'],
    queryFn: getAllPenalties,
    enabled: shouldFetchPenalties,
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  });

  return {
    ...queryResult,
    data: queryResult.data ? {
      individualPenalties: queryResult.data.individualPenalties || [],
      bulkPenalty: queryResult.data.bulkPenalty || null
    } : { individualPenalties: [], bulkPenalty: null }
  };
};
